<template>
  <div :class="$style.container">
    <div :class="$style.comment">
      <div :class="$style.header">Внутренние комментарии:</div>
      <textarea v-model="comment" :class="$style.body" placeholder="Введите текст..." @blur="onBlur"></textarea>
      <div :class="[$style.loading, status && $style.loadingActive]">
        <span v-if="status === 'save'">Сохранение...</span>
        <span v-if="status === 'done'">Сохранено</span>
      </div>
    </div>

    <div v-if="isCancelled" :class="$style.comment">
      <div :class="$style.header">Причина отклонения:</div>
      <div :class="[$style.body, $style.bodyDisabled]">{{ cancelReason }}</div>
    </div>

    <div v-if="isDone" :class="$style.comment">
      <div :class="$style.header">Произведенные действия:</div>
      <div :class="[$style.body, $style.bodyDisabled]">{{ doneActions }}</div>
    </div>
  </div>
</template>

<script>
import parseJSON                                         from "@/utils/parseJSON";
import { ISSUE_STATUS_CANCELLED, ISSUE_STATUS_COMPLETE } from "@/constants/issues";

export default {
  name:     "IssueComment",
  props:    ['issue', 'onUpdate'],
  data() {
    return {
      comment:      '',
      cancelReason: '',
      doneActions:  '',
      status:       null,
    };
  },
  computed: {
    isCancelled() {
      return this.issue.status_id === ISSUE_STATUS_CANCELLED;
    },
    isDone() {
      return this.issue.status_id === ISSUE_STATUS_COMPLETE;
    },
  },
  methods:  {
    updateComment() {
      const additional = parseJSON(this.issue.additional) || {};
      this.comment = additional.comments;
      this.cancelReason = additional.cancelReason;
      this.doneActions = additional.doneActions;
    },

    onBlur() {
      const additional = parseJSON(this.issue.additional) || {};
      if (this.comment !== additional.comments) {
        additional.comments = this.comment;
        this.status = 'save';
        this.onUpdate({ additional: JSON.stringify(additional) }).then(() => {
          this.status = 'done';
          setTimeout(() => this.status = null, 2000);
        });
      }
    },
  },
  mounted() {
    this.updateComment();
  },
  watch:    {
    issue() {
      this.updateComment();
    },
  },
};
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  //height: 100%;
  //flex: 1;
}

.comment {
  flex: 1;
  position: relative;
  border: 1px solid #A9A9A9;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  min-height: 140px;

  &:last-child {
    margin-bottom: 0;
  }
}

.header {
  font-weight: 600;
  border-bottom: 1px solid #A9A9A9;
  background: #f3f3f3;
  color: #000000;
  padding: 0 15px;
  height: 45px;
  display: flex;
  align-items: center;
}

.body {
  flex: 1;
  border: 0;
  resize: none;
  min-width: 100%;
  max-width: 100%;
  padding: 15px;
  font: inherit;
  word-wrap: break-word;
  white-space: pre-line;
}

.bodyDisabled {
  background: #f3f3f3;
}

.loading {
  font-size: 1.05rem;
  position: absolute;
  right: 20px;
  bottom: 15px;
  opacity: 0;
  pointer-events: none;
  @include anim()
}

.loadingActive {
  opacity: 1;
}

</style>
